export const iconFontAwesomeFilmVideoHeadphones = (
	<i className="fa-solid fa-headphones"></i>
);
